import Vue from 'vue'
Vue.config.productionTip = false

//import FluxWebCommunication from 'flux-web-communication';
//Vue.use(FluxWebCommunication);

// vue-material
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import 'vue-material-design-icons/styles.css'
import 'vue-js-modal/dist/styles.css'
Vue.use(VueMaterial)

import VueTimers from 'vue-timers'
Vue.use(VueTimers)

import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);

// vue-js-modal
import VModal from 'vue-js-modal/dist/index.nocss.js'
Vue.use(VModal)


import App from './App.vue'
import store from './store'
import {i18n} from '@/plugins/i18n';


new Vue({
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
